module.exports = __webpack_public_path__ + "img/B.8c17f32d.png";